import React, { Suspense } from 'react';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { Spinner } from '../../../controls/Spinner/Spinner';
import { useHasAppointment } from '../../../context/Appointment/appointment';
import { useKioskState } from '../../../context/Kiosk/kiosk';

export interface IProps {
    onProceed: (needsAdditionalServices: boolean, typeComments: boolean) => void;
}

export const SkipServices: React.FC<
    IProps & {
        /** The screen should be disabled and skipped */ onDisabled: () => void;
    }
> = ({ onDisabled, ...props }) => {
    const hasAppointment = useHasAppointment();
    const {
        dealer: { straightToServicesForAppointments },
    } = useKioskState();
    const Skip = React.lazy(() => (isElectron() ? import('./KioskSkipServices') : import('./WebSkipServices')));

    React.useEffect(() => {
        if (!hasAppointment || straightToServicesForAppointments) {
            onDisabled();
        }
    }, [hasAppointment, onDisabled, straightToServicesForAppointments]);

    return (
        !hasAppointment || straightToServicesForAppointments ?
            <Spinner /> :
            <Suspense fallback={<Spinner />}>
                <Skip {...props} />
            </Suspense>
    );
};
